import { loadTokenFromStorage } from "actions/user";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import loadTokenStatusSelector from "selectors/loadTokenStatus";
import AnimationRoot from "ui/animation/AnimationRoot";
import FreeRoot from "ui/free/FreeRoot";
import HomeRoot from "ui/home/HomeRoot";
import WelcomeRoot from "ui/welcome/WelcomeRoot";

const Router: React.FC = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loadTokenFromStorage());
    }, [dispatch]);

    const status = useSelector(loadTokenStatusSelector);

    if (status === "loading") {
        return <div>Loading...</div>;
    }

    return (
        <Switch>
            <Route path="/welcome">
                <WelcomeRoot />
            </Route>
            <Route path="/home">
                <HomeRoot />
            </Route>
            <Route path="/animation">
                <AnimationRoot />
            </Route>
            <Route path="/">
                <FreeRoot />
            </Route>
        </Switch>
    );
};

export default Router;
